<template>
  <div class="px-20">
    <vs-popup
      class="custom-popup editPromo-popup"
      classContent="popup-example"
      :title="`${formData['actionName']} MIS`"
      :active.sync="editPromoRequestPopup"
    >
      <div slot="header">Edit MIS</div>

      <div class="static-box-header">
        <div class="header">MIS</div>
        <div class="form-actions">
          <vx-tooltip text="Copy any end date manually and click here to paste it to all entries" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-copy"
              @click="copyEndDate"
            ></vs-button>
          </vx-tooltip>
        </div>
      </div>

      <div class="misPromo-editForm table-form pr-4 pl-4">
        <ul class="table-head">
          <li class="theading">Client Name</li>
          <li class="theading">TLD</li>
          <li class="theading">Type</li>
          <li class="theading">Period (Yrs)</li>
          <li class="theading">Start Date</li>
          <li class="theading">End Date</li>
          <li class="theading">Effective 1Yr Price</li>
          <li class="theading">Effective Multi-Yr Price</li>
          <!-- <li class="theading">Comments</li> -->
        </ul>
        <div v-for="(misItem, counter) in mis" v-bind:key="counter">
          <ul class="mis-repeater table-body">
            <li>
              <div class="table-form-component flex">
                <v-select
                  :name="`reseller-${counter}`"
                  class="w-4/5"
                  v-model="misItem.reseller_id"
                  :options="formResellers"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :clearable="false"
                  :disabled="flags['disableInput']"
                ></v-select>
              </div>
            </li>
            <li>
              <div class="table-form-component">
                <v-select
                  :name="`mis tld-${counter}`"
                  class="w-full"
                  v-model="misItem.tld_id"
                  :options="formTlds"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :multiple="false"
                  :closeOnSelect="true"
                  :clearable="false"
                  :disabled="flags['disableInput']"
                ></v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`mis tld-${counter}`)"
                  >Required field</span
                >
              </div>
            </li>
            <li>
              <div class="table-form-component">
                <v-select
                  :name="`mis type-${counter}`"
                  class="w-full"
                  v-model="misItem.type"
                  :options="formInit['types']"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :clearable="false"
                  :disabled="flags['disableInput']"
                ></v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`mis type-${counter}`)"
                  >Required field</span
                >
              </div>
            </li>
            <li>
              <div class="table-form-component">
                <v-select
                  :name="`mis period-${counter}`"
                  class="w-full"
                  v-model="misItem.period"
                  :options="formInit['periods']"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :multiple="true"
                  :closeOnSelect="false"
                  :clearable="false"
                  @input="handlePeriod($event)"
                  :selectable="
                    misItem.selectableOption !== '' &&
                    misItem.selectableOption === 'All'
                      ? (option) => option === '1'
                      : misItem.selectableOption === ''
                      ? (option) => true
                      : (option) => option !== '1'"
                  :disabled="flags['disableInput']">
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`mis period-${counter}`)"
                  >Required field</span
                >
              </div>
            </li>
            <li>
              <div class="table-form-component">
                <div class="relative">
                  <flat-pickr
                    :name="`mis start date-${counter}`"
                    v-model="misItem.start_date"
                    placeholder="YYYY-MM-DD"
                    class="w-full"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    :config="misItem.configFromdateTimePicker"
                    @on-change="onFromChangeMIS($event, counter)"
                    :disabled="flags.isApproved"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`mis start date-${counter}`)"
                  >Required field</span
                >
              </div>
            </li>
            <li>
              <div class="table-form-component">
                <div class="relative">
                  <flat-pickr
                    :name="`mis end date-${counter}`"
                    v-model="misItem.end_date"
                    placeholder="YYYY-MM-DD"
                    class="w-full"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    :config="misItem.configTodateTimePicker"
                    @on-change="onToChangeMIS($event, counter)"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`mis end date-${counter}`)"
                  >Required field</span
                >
              </div>
            </li>
            <li>
              <div class="table-form-component">
                <div
                  v-if="misItem.type.includes('premium')"
                  class="inputPrefix"
                >
                  <vs-input
                    placeholder=""
                    :name="`mis year price per-${counter}`"
                    class="w-full"
                    v-validate="
                      misItem.disabledYearPrice ? '' : formData['misRequired']
                    "
                    data-vv-validate-on="blur"
                    v-model="misItem.year_price_per"
                    icon-pack="feather"
                    icon="icon-percent"
                    icon-no-border
                    :key="`permis-input-${counter}`"
                    :disabled="misItem.disabledYearPrice"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`mis year price per-${counter}`)"
                  >
                    Required field
                  </span>
                </div>
                <div v-else class="inputPrefix">
                  <vs-input
                    placeholder=""
                    :name="`mis year price-${counter}`"
                    class="w-full"
                    v-validate="
                      flags['enabledMIS'] && !misItem.disabledYearPrice
                        ? 'required'
                        : ''
                    "
                    data-vv-validate-on="blur"
                    v-model="misItem.year_price"
                    icon-pack="feather"
                    icon="icon-dollar-sign"
                    icon-no-border
                    :key="`amtmis-input-${counter}`"
                    :disabled="misItem.disabledYearPrice"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`mis year price-${counter}`)"
                  >
                    Required field
                  </span>
                </div>
              </div>
            </li>
            <li>
              <div class="table-form-component">
                <div
                  v-if="misItem.type.includes('premium')"
                  class="inputPrefix"
                >
                  <vs-input
                    placeholder=""
                    :name="`mis multi year price per-${counter}`"
                    class="w-full"
                    v-validate="
                      flags['enabledMIS'] && !misItem.period.includes('1')
                        ? 'required'
                        : ''
                    "
                    data-vv-validate-on="blur"
                    v-model="misItem.multi_year_price_per"
                    icon-pack="feather"
                    icon="icon-percent"
                    icon-no-border
                    :key="`permis-multi-input-${counter}`"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`mis multi year price per-${counter}`)"
                  >
                    Required field
                  </span>
                </div>
                <div v-else class="inputPrefix">
                  <vs-input
                    placeholder=""
                    :name="`mis multi year price-${counter}`"
                    class="w-full"
                    v-validate="
                      flags['enabledMIS'] && !misItem.period.includes('1')
                        ? 'required'
                        : ''
                    "
                    data-vv-validate-on="blur"
                    v-model="misItem.multi_year_price"
                    icon-pack="feather"
                    icon="icon-dollar-sign"
                    icon-no-border
                    :key="`amtmis-multi-input-${counter}`"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`mis multi year price-${counter}`)"
                  >
                    Required field
                  </span>
                </div>
              </div>
            </li>
            <!-- <li>
              <div class="table-form-component">
                <vs-input
                  :name="`mis comments-${counter}`"
                  class="w-full"
                  v-model="misItem.comments"
                  data-vv-validate-on="blur"
                  :clearable="false"
                ></vs-input>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
      <div class="flex justify-end pb-4 pr-4 pt-2">
        <vs-button
          v-show="!flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onEditSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onDuplicateSubmit()"
          >Save</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";

export default {
  name: "EditMISPromo",
  components: {
    "v-select": vSelect,
    flatPickr,
    vueCustomScrollbar,
  },
  // props: {
  //   editReq: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data() {
    return {
      editReq: false,
      mis: [
        {
          reseller_id: [],
          tld_id: [],
          type: [],
          period: [],
          start_date: null,
          end_date: null,
          year_price: "",
          multi_year_price: "",
          year_price_per: "",
          multi_year_price_per: "",
          selectableOption: "",
          disabledYearPrice: false,
          list_based: "",
          comments: "",
          configFromdateTimePicker: {
            // minDate: new Date(),
            maxDate: null,
            wrap: true,
            //maxDate: new Date().fp_incr(2),
          },
          configTodateTimePicker: {
            minDate: null,
            wrap: true,
          },
        },
      ],
      formData: {
        actionName: "",
        reject_comments: "",
      },
      formInit: {
        reseller_ids: [],
        tld_ids: [],
        types: ["new", "renew", "premium new", "premium renew"],
        periods: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      },
      batchId: "",
      status: "",
      activePrompt: false,
      activePrompt: false,
      rejectPromoId: "",
      editPromoRequestPopup: false,
      flags: {
        isApproved: false,
        isDuplicate: false,
        disableInput: false,
        duplicatebtn: false,
      },
      extended: false,
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
    };
  },
  mounted() {
    let self = this;

    this.$root.$on("selectedGroupEditMIS", (nodeData, extended, editReq) => {
      if (extended) {
        this.extended = true;
      }

      if (editReq) {
        this.editReq = true;
      }

      this.formatGroupEditData(nodeData);
      this.formData["actionName"] = "Edit";
      this.editPromoRequestPopup = true;
    });

    this.$root.$on("duplicatePromoMIS", (nodeData) => {
      // this.formatGroupEditData(nodeData);
      this.formatSingleDuplicateData(nodeData);
      this.editPromoRequestPopup = true;
      this.flags["duplicatebtn"] = true;
      this.formData["actionName"] = "Duplicate";
    });

    // --- Populate dropdown elements ---

    // NOTE: Before Vuex usage
    // Get clients
    // self.$axiosSecure
    //   .get("/resellers")

    //   .then((response) => {
    //     self.formInit["reseller_ids"] = response.data;
    //   })
    //   .catch((error) => {
    //     // Error notification
    //     self.$vs.notify({
    //       color: "danger",
    //       title: "Something went wrong",
    //       text: "Please contact the server admin",
    //     });
    //     console.log(error);
    //   });

    // // Get tlds
    // self.$axiosSecure
    //   .get("/tlds")

    //   .then((response) => {
    //     self.formInit["tld_ids"] = response.data;
    //   })
    //   .catch((error) => {
    //     // Error notification
    //     self.$vs.notify({
    //       color: "danger",
    //       title: "Something went wrong",
    //       text: "Please contact the server admin",
    //     });
    //     console.log(error);
    //   });

    // Get internal Promo list
    // self.$axiosSecure
    //   .get("/agreement/general")

    //   .then((response) => {
    //     self.formInit["agreements"] = response.data;
    //     // console.log(response.data);
    //   })
    //   .catch((error) => {
    //     // Error notification
    //     self.$vs.notify({
    //       color: "danger",
    //       title: "Something went wrong",
    //       text: "Please contact the server admin",
    //     });
    //     console.log(error);
    //   });

    // Get promo type
    // self.$axiosSecure
    //   .get("/promo-tags")

    //   .then((response) => {
    //     self.formInit["promo_tags"] = response.data;
    //   })
    //   .catch((error) => {
    //     // Error notification
    //     self.$vs.notify({
    //       color: "danger",
    //       title: "Something went wrong",
    //       text: "Please contact the server admin",
    //     });
    //     console.log(error);
    //   });

    // // Get promo type
    // self.$axiosSecure
    //   .get("/currencies")

    //   .then((response) => {
    //     self.formInit["geos"] = response.data;
    //   })
    //   .catch((error) => {
    //     // Error notification
    //     self.$vs.notify({
    //       color: "danger",
    //       title: "Something went wrong",
    //       text: "Please contact the server admin",
    //     });
    //     console.log(error);
    //   });

    // // Get Custom type
    // self.$axiosSecure
    //   .get("/custom-tags")

    //   .then((response) => {
    //     self.formInit["custom_tags"] = response.data;
    //     self.formData["TagNameData"] = response.data.map((x) => x.tag_name);
    //   })
    //   .catch((error) => {
    //     // Error notification
    //     self.$vs.notify({
    //       color: "danger",
    //       title: "Something went wrong",
    //       text: "Please contact the server admin",
    //     });
    //     console.log(error);
    //   });

    // ---! Populate dropdown elements !---
  },
  beforeMount() {},
  destroyed() {
    this.$root.$off("selectedGroupEdit");
  },
  watch: {
    editPromoRequestPopup(val) {
      if (!val) {
        this.errors.clear();
        setTimeout(() => {
          this.flags["duplicatebtn"] = false;
          this.flags["disableInput"] = false;
        }, 10);
      }
    },

    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },
  },
  computed: {
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },

    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },

    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },

    // NOTE: Before Vuex usage
    // formResellers: function () {
    //   let resellerArray = this.formInit["reseller_ids"].map((x) => {
    //     return {
    //       label: x["name"],
    //       value: x["id"],
    //     };
    //   });

    //   return resellerArray;
    // },

    // formTlds: function () {
    //   let tldArray = this.formInit["tld_ids"].map((x) => {
    //     return {
    //       label: x["tld_name"],
    //       value: x["id"],
    //       name: x["tld_name"],
    //     };
    //   });

    //   return tldArray;
    // },

    validComment() {
      return this.formData["reject_comments"].length > 0;
    },
    rejectTitle() {
      return "Reject Selected MIS?";
    },
    yesText() {
      return "Yes";
    },
    noText() {
      return "No";
    },
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    onFromChangeMIS(event, counter) {
      this.$set(this.mis[counter].configTodateTimePicker, "minDate", event[0]);
      // console.log('counter', counter);
      // console.log('event', event);
    },
    onToChangeMIS(event, counter) {
      this.$set(
        this.mis[counter].configFromdateTimePicker,
        "maxDate",
        event[0]
      );
    },
    handlePeriod(event) {
      // console.log("event :>> ", event);
      this.mis.forEach((element) => {
        if (element["period"]) {
          if (!element["period"].length) {
            element["selectableOption"] = "";
            element["disabledYearPrice"] = false;
            element["disabledMultiYearPrice"] = false;
          } else {
            if (element["period"].includes("1")) {
              element["selectableOption"] = "All";
              element["disabledYearPrice"] = false;
            } else {
              element["selectableOption"] = "Other than All";
              if (element["period"].length == 1) {
                element["disabledYearPrice"] = true;
                // console.log('disabledYearPrice true');
              } else {
                element["disabledYearPrice"] = false;
                // console.log('disabledYearPrice false');
              }
            }
          }
        }
      });
    },
    formatGroupEditData(nodeData) {
      var groupData = nodeData;

      //   var multipleEditData = groupData[0];
      //   var singleEditData = multipleEditData[0];

      this.mis.splice(0);

      //   this.batchId = singleEditData.batch_id;

      var getTempMISReseller,
        getTempMISType,
        getTempMISTLD,
        getTempMISPeriod,
        getTempMISListBased,
        getTempMISStartDate,
        getTempMISEndDate,
        getTempMISYearPrice,
        getTempMISMultiYearPrice,
        getTempMISYearPerPrice,
        getTempMISMultiYearPerPrice,
        getTempMISId,
        getTempMISRecordId,
        getTempMISComments;

      var approvedCheck = groupData.map((x) => x.approved_by);
      this.flags["isApproved"] = approvedCheck.some(x => x);

      if (approvedCheck.some(x => x)) {
        this.flags["disableInput"] = true;
        // console.log("yes", approvedCheck);
      } else {
        this.flags["disableInput"] = false;
        // console.log("no", approvedCheck);
      }

      getTempMISType = groupData.map((x) => x.type);
      getTempMISReseller = groupData.map((x) => {
        return {
          label: x.new_reseller.name,
          value: x.new_reseller_id,
        };
      });
      getTempMISTLD = groupData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld_id,
        };
      });
      getTempMISId = groupData.map((x) => x.id);
      getTempMISRecordId = groupData.map((x) => x.mis_id);
      getTempMISPeriod = groupData.map((x) => x.period);
      getTempMISStartDate = groupData.map((x) => x.start_date);
      getTempMISEndDate = groupData.map((x) => x.end_date);
      getTempMISYearPrice = groupData.map((x) => x.effective_first);
      getTempMISMultiYearPrice = groupData.map((x) => x.effective_multi);
      getTempMISYearPerPrice = groupData.map((x) => x.effective_first_per);
      getTempMISMultiYearPerPrice = groupData.map((x) => x.effective_multi_per);
      getTempMISListBased = groupData.map((x) => x.list_based);
      getTempMISComments = groupData.map((x) => x.comments);

      // var datedate = [];

      // if (groupData[0].approved_by) {
      //   // console.log('val');
      //   this.flags["isApproved"] = true;
      //   this.status = "active";
      //   if (this.flags["isDuplicate"]) {
      //     this.flags["isApproved"] = false;
      //     this.status = "new pending";
      //     for (var index = 0; index < groupData.length; index++) {
      //       datedate.push(null);
      //       getTempMISStartDate = datedate;
      //       getTempMISEndDate = datedate;
      //     }
      //   }
      // } else {
      //   // console.log('notval');
      //   this.flags["isApproved"] = false;
      //   this.status = "new pending";
      // }

      // console.log('list_based', tempListBased);

      var totalMISArray = groupData.length;
      // Pushing data into MIS promo
      for (var index = 0; index < totalMISArray; index++) {
        // console.log('push')
        this.mis.push({
          id: getTempMISId[index],
          mis_record_id: getTempMISRecordId[index],
          reseller_id: getTempMISReseller[index],
          type: getTempMISType[index],
          tld_id: getTempMISTLD[index],
          period: getTempMISPeriod[index],
          year_price: getTempMISYearPrice[index],
          multi_year_price: getTempMISMultiYearPrice[index],
          year_price_per: getTempMISYearPerPrice[index],
          multi_year_price_per: getTempMISMultiYearPerPrice[index],
          start_date: getTempMISStartDate[index],
          end_date: getTempMISEndDate[index],
          list_based: getTempMISListBased[index],
          comments: getTempMISComments[index],
          configFromdateTimePicker: {
            maxDate: null,
            wrap: true,
          },
          configTodateTimePicker: {
            minDate: null,
            wrap: true,
          },
        });

        this.$set(this.mis[index].configTodateTimePicker, "minDate", getTempMISStartDate[index],);
      }
    },
    formatSingleDuplicateData(nodeData) {
      var groupData = nodeData;

      //   var multipleEditData = groupData[0];
      //   var singleEditData = multipleEditData[0];

      this.mis.splice(0);

      //   this.batchId = singleEditData.batch_id;

      var getTempMISReseller,
        getTempMISType,
        getTempMISTLD,
        getTempMISPeriod,
        getTempMISListBased,
        getTempMISStartDate,
        getTempMISEndDate,
        getTempMISYearPrice,
        getTempMISMultiYearPrice,
        getTempMISYearPerPrice,
        getTempMISMultiYearPerPrice,
        getTempMISId,
        getTempMISComments;

      getTempMISType = groupData.map((x) => x.type);
      getTempMISReseller = groupData.map((x) => {
        return {
          label: x.new_reseller.name,
          value: x.new_reseller_id,
        };
      });
      getTempMISTLD = groupData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld_id,
        };
      });
      getTempMISId = groupData.map((x) => x.id);
      getTempMISPeriod = groupData.map((x) => x.period);
      getTempMISStartDate = groupData.map((x) => x.start_date);
      getTempMISEndDate = groupData.map((x) => x.end_date);
      getTempMISYearPrice = groupData.map((x) => x.effective_first);
      getTempMISMultiYearPrice = groupData.map((x) => x.effective_multi);
      getTempMISYearPerPrice = groupData.map((x) => x.effective_first_per);
      getTempMISMultiYearPerPrice = groupData.map((x) => x.effective_multi_per);
      getTempMISListBased = groupData.map((x) => x.list_based);
      getTempMISComments = groupData.map((x) => x.comments);

      // console.log('list_based', tempListBased);

      this.flags["isApproved"] = false;

      var totalMISArray = groupData.length;
      // Pushing data into MIS promo
      for (var index = 0; index < totalMISArray; index++) {
        // console.log('push')
        this.mis.push({
          id: getTempMISId[index],
          reseller_id: getTempMISReseller[index],
          type: getTempMISType[index],
          tld_id: getTempMISTLD[index],
          period: getTempMISPeriod[index],
          year_price: getTempMISYearPrice[index],
          multi_year_price: getTempMISMultiYearPrice[index],
          year_price_per: getTempMISYearPerPrice[index],
          multi_year_price_per: getTempMISMultiYearPerPrice[index],
          start_date: null,
          end_date: null,
          list_based: getTempMISListBased[index],
          comments: getTempMISComments[index],
          configFromdateTimePicker: {
            minDate: new Date(this.$moment().subtract(9, 'months')),
            maxDate: null,
            wrap: true,
          },
          configTodateTimePicker: {
            minDate: null,
            wrap: true,
          },
        });
      }

      this.handlePeriod(true);
    },
    onSubmit() {
      var misPriceObject = {
        amtNum: [],
        perNum: [],
        amtMulti: [],
        perMulti: [],
      };

      this.mis.forEach((x) => {
        if (!x.type.includes("premium")) {
          misPriceObject["amtNum"].push(
            (Math.round(x.year_price * 100) / 100).toFixed(2)
          );
          misPriceObject["amtMulti"].push(
            (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
          );
          misPriceObject["perNum"].push(0);
          misPriceObject["perMulti"].push(0);
        } else {
          misPriceObject["amtNum"].push(0);
          misPriceObject["amtMulti"].push(0);
          misPriceObject["perNum"].push(
            (Math.round(x.year_price_per * 100) / 100).toFixed(2)
          );
          misPriceObject["perMulti"].push(
            (Math.round(x.multi_year_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      var misData = this.mis.map((x, index) => {
        return {
          id: x.id,
          list_based: x.list_based,
          // reseller_id: x.reseller_id.value,
          new_reseller_id: x.reseller_id.value,
          tld_id: x.tld_id.value,
          type: x.type,
          period: x.period,
          start_date: x.start_date,
          end_date: x.end_date,
          effective_first: misPriceObject["amtNum"][index],
          effective_multi: misPriceObject["amtMulti"][index],
          effective_first_per: misPriceObject["perNum"][index],
          effective_multi_per: misPriceObject["perMulti"][index],
          status: "approval pending",
          comments: x.comments,
        };
      });
      // console.log(misData);
      // return;
      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          //Loader
          this.openLoadingInDiv();
          this.$axiosSecure
            .post("/mis-records-requests/edit", misData)
            .then((response) => {
              // console.log(response.data);
              // Hide loader
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "MIS Record edited",
                  text: "Selected MIS record has been successfully edited.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
                this.editPromoRequestPopup = false;
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              setTimeout(() => {
                //Error msg
                if (
                  error.response.data.resoneOfError == "MIS duplicate" ||
                  error.response.data.resoneOfError == "timeerror" ||
                  error.response.data.resoneOfError == "mis duplicate" ||
                  error.response.data.resoneOfError == "Date OverLapping"
                ) {
                  this.errorMessage = error.response.data.message;
                } else if(error.response.data.type == "Error" && error.response.data.data && error.response.data.data.length) {
                  this.mis = this.mis.filter(x => error.response.data.data.includes(x.id));
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    onEditSubmit() {
      var misData = {};

      var misPriceObject = {
        amtNum: [],
        perNum: [],
        amtMulti: [],
        perMulti: [],
      };

      this.mis.forEach((x) => {
        if (!x.type.includes("premium")) {
          misPriceObject["amtNum"].push(
            (Math.round(x.year_price * 100) / 100).toFixed(2)
          );
          misPriceObject["amtMulti"].push(
            (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
          );
          misPriceObject["perNum"].push(0);
          misPriceObject["perMulti"].push(0);
        } else {
          misPriceObject["amtNum"].push(0);
          misPriceObject["amtMulti"].push(0);
          misPriceObject["perNum"].push(
            (Math.round(x.year_price_per * 100) / 100).toFixed(2)
          );
          misPriceObject["perMulti"].push(
            (Math.round(x.multi_year_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      misData = this.mis.map((x, index) => {
        return {
          id: this.editReq ? x.id : undefined,
          // list_based: x.list_based,
          mis_id: this.editReq ? x.mis_record_id : x.id,
          start_date: x.start_date,
          end_date: x.end_date,
          effective_first: misPriceObject["amtNum"][index],
          effective_multi: misPriceObject["amtMulti"][index],
          effective_first_per: misPriceObject["perNum"][index],
          effective_multi_per: misPriceObject["perMulti"][index],
          status: "edit pending",
          comments: x.comments,
          extended: this.extended,
        };
      });

      // console.log("misData", misData);
      // return;

      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();
          // this.flags["isFormSubmitted"] = true;

          let url = this.editReq ? "/mis-records/edit/requests" : "/mis-records/edit";

          this.$axiosSecure
            .post(url, misData)
            .then((response) => {
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              // console.log(response.data);
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "MIS Record edited",
                  text: "Selected MIS record has been successfully edited.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              //   console.log(error.response.message);
              // if (error.response.data.message == "Duplicate") {
              setTimeout(() => {
                //Error msg
                if (
                  error.response.data.resoneOfError == "CNIC duplicate" ||
                  error.response.data.resoneOfError == "timeerror" ||
                  error.response.data.resoneOfError == "mis duplicate" ||
                  error.response.data.resoneOfError == "Date OverLapping"
                ) {
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
              // }
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    onDuplicateSubmit() {
      var misPriceObject = {
        amtNum: [],
        perNum: [],
        amtMulti: [],
        perMulti: [],
      };

      this.mis.forEach((x) => {
        if (!x.type.includes("premium")) {
          misPriceObject["amtNum"].push(
            (Math.round(x.year_price * 100) / 100).toFixed(2)
          );
          misPriceObject["amtMulti"].push(
            (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
          );
          misPriceObject["perNum"].push(0);
          misPriceObject["perMulti"].push(0);
        } else {
          misPriceObject["amtNum"].push(0);
          misPriceObject["amtMulti"].push(0);
          misPriceObject["perNum"].push(
            (Math.round(x.year_price_per * 100) / 100).toFixed(2)
          );
          misPriceObject["perMulti"].push(
            (Math.round(x.multi_year_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      // var misData = this.mis.map((x, index) => {
      //   return {
      //     // id: x.id,
      //     list_based: x.list_based,
      //     user_id: JSON.parse(localStorage.getItem("userDetails")).id,
      //     reseller_id: x.reseller_id.value,
      //     tld_id: x.tld_id.value,
      //     type: x.type,
      //     period: x.period,
      //     start_date: x.start_date,
      //     end_date: x.end_date,
      //     effective_first: misPriceObject["amtNum"][index],
      //     effective_multi: misPriceObject["amtMulti"][index],
      //     effective_first_per: misPriceObject["perNum"][index],
      //     effective_multi_per: misPriceObject["perMulti"][index],
      //     status: "approval pending",
      //     comments: x.comments,
      //   };
      // });
      // console.log(misData);
      // return;
      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();
          this.$axiosSecure
            .post("/mis-records-request/duplicate", {
              list_based: this.mis[0].list_based,
              user_id: JSON.parse(localStorage.getItem("userDetails")).id,
              // reseller_id: this.mis[0].reseller_id.value,
              new_reseller_id: this.mis[0].reseller_id.value,
              status: "approval pending",
              comments: this.mis[0].comments,
              mis: [
                {
                  tld_id: [this.mis[0].tld_id.value],
                  type: this.mis[0].type,
                  period: this.mis[0].period,
                  start_date: this.mis[0].start_date,
                  end_date: this.mis[0].end_date,
                  effective_first: misPriceObject["amtNum"][0],
                  effective_multi: misPriceObject["amtMulti"][0],
                  effective_first_per: misPriceObject["perNum"][0],
                  effective_multi_per: misPriceObject["perMulti"][0],
                },
              ],
            })
            .then((response) => {
              // console.log(response.data);
              // Hide loader
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "MIS Record duplicated",
                  text: "Selected MIS record has been successfully duplicated.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              setTimeout(() => {
                //Error msg
                if (
                  error.response.data.resoneOfError == "CNIC duplicate" ||
                  error.response.data.resoneOfError == "timeerror" ||
                  error.response.data.resoneOfError == "mis duplicate" ||
                  error.response.data.resoneOfError == "Date OverLapping"
                ) {
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    resetComment() {
      this.formData["reject_comments"] = "";
    },

    resetFields() {
      (this.batchId = ""),
      (this.status = ""),
      this.mis.forEach((element) => {
        (element.reseller_id = []),
          (element.tld_id = []),
          (element.type = []),
          (element.period = []),
          (element.start_date = null),
          (element.end_date = null),
          (element.year_price = ""),
          (element.year_price_per = ""),
          (element.multi_year_price = ""),
          (element.multi_year_price_per = ""),
          (element.selectableOption = ""),
          (element.disabledYearPrice = false);
      });
      this.flags = {
        isApproved: false,
        isDuplicate: false,
        disableInput: false,
        duplicatebtn: false,
      }
      this.mis.splice(1);
    },

    tableRefresh() {
      this.$root.$emit("tableRefresh");
    },

    onFromChangeMIS(event, counter) {
      this.$set(this.mis[counter].configTodateTimePicker, "minDate", event[0]);
    },

    onToChangeMIS(event, counter) {
      this.$set(
        this.mis[counter].configFromdateTimePicker,
        "maxDate",
        event[0]
      );
    },

    copyEndDate() {
      navigator.clipboard.readText().then(
          (textCopied) => {
            this.mis.map(x => {
              x.end_date = textCopied.toString();
            })
          },
          (err) => {
              console.error('Could not paste text: ', err)
          }
      );
    }
  },
};
</script>

<style>
</style>